export const parseSubmissionPaymentAmount = (
  value?: number | string | null
): number => {
  if (value == null || value === '') {
    return 0;
  }
  const parsed = Number(value);
  return Number.isNaN(parsed) ? 0 : parsed;
};

export default parseSubmissionPaymentAmount;
